import { IxAuftragGridFilter } from 'pages/auftrag.gen/auftrag-grid-filter.gen'
import { ClearingFilters } from 'test-pages/clearing'
import { Ix2000biFilter } from 'pages/ix-2000bi.gen/2000bi-filter.gen'
import { Ix20011Filter } from 'pages/ix-20011.gen/20011-filter.gen'
import { Ix2031Filter } from 'pages/ix-2031.gen/2031-filter.gen'
import { Ix2044GridFilter } from 'pages/ix-2044.gen/2044-grid-filter.gen'
import { Ix2048GridFilter } from 'pages/ix-2048.gen/2048-grid-filter.gen'
import { Ix2060Filter } from 'pages/ix-2060.gen/2060-filter.gen'
import { Ix2067Filter } from 'pages/ix-2067.gen/2067-filter.gen'
import { Ix2076Filter } from 'pages/ix-2076.gen/2076-filter.gen'
import { IxMeldungGridFilter } from 'pages/meldung.gen/meldung-grid-filter.gen'
import { StatementFilters } from 'pages/account-statement/statement-filters'
import { IxTOGridFilter } from 'pages/to.gen/to-grid-filter.gen'
import { Ix1033Filter } from 'pages/ix-1033.gen/1033-filter.gen'
import { IxXspgetzlgtlrzGridFilter } from 'pages/xspgetzlgtlrz.gen/xspgetzlgtlrz-grid-filter.gen'

export const filters: any = {
    'auftragFilter': IxAuftragGridFilter,
    'clearingFilters': ClearingFilters,
    'ix2000biFilter': Ix2000biFilter,
    'ix20011Filter': Ix20011Filter,
    'ix2031Filter': Ix2031Filter,
    'ix2044Filter': Ix2044GridFilter,
    'ix2048Filter': Ix2048GridFilter,
    'ix2060Filter': Ix2060Filter,
    'ix2067Filter': Ix2067Filter,
    'ix2076Filter': Ix2076Filter,
    'meldungFilter': IxMeldungGridFilter,
    'statementFilter': StatementFilters,
    'toFilter': IxTOGridFilter,
    'umlFilter': Ix1033Filter,
    'xspgetzlgtlrzFilter': IxXspgetzlgtlrzGridFilter,
}
